/**
 * KAN-910: развёрнутый на весь экран вид таблицы и доски CRM в адресе (?full=1),
 * чтобы ссылка открывала тот же вид. Поведение (Esc, блок прокрутки) - useFullscreenToggle.
 * KAN-957: useCrmFullscreenValue - только флаг, без Esc и блока прокрутки (для секции,
 * которая решает, где рисовать фильтры; поведение держит сам развёрнутый блок).
 */
import { useMemo } from 'react';
import { useFullscreenToggle } from '@/hooks/useFullscreenToggle';
import { useUrlState } from '@/hooks/useUrlState';

export const CRM_FULLSCREEN_PARAM = 'full';

export function useCrmFullscreenValue(): boolean {
  return useUrlState().params.get(CRM_FULLSCREEN_PARAM) === '1';
}

export function useCrmFullscreen() {
  const { setParam } = useUrlState();
  const value = useCrmFullscreenValue();
  const control = useMemo(
    () => ({ value, set: (next: boolean) => setParam(CRM_FULLSCREEN_PARAM, next ? '1' : null) }),
    [value, setParam]
  );
  return useFullscreenToggle(false, control);
}
